// 1）点击类埋点：用事件委托
// 2）曝光类埋点

/**
 * 1. 全局绑定一次点击事件
 * 2. 各模块曝光、和特殊逻辑按照各模块自己init处理
 */
// assets/tracking.js
(function () {
    'use strict';

    // =========================================================
    // 1. 全局状态
    // =========================================================
    window.dataLayer = window.dataLayer || [];

    // =========================================================
    // 2. 通用上报方法
    // =========================================================
    function track(payload) {

       if (payload && payload.event === 'view_promotion') {
            setTimeout(() => {
                window.dataLayer.push(payload);
                // console.log('[TRACK]', { ...payload });
            }, 6000); // 等待10ms让page view事件先触发
        } else {
            window.dataLayer.push(payload);
            // console.log('[TRACK]', { ...payload });
        }
    }

    // =========================================================
    // 3. helper:
    // =========================================================
    // 1）获取data-track-xxx属性值
    function getDataset(el, key, fallback = null) {
        if (!el || !el.dataset) return fallback;
        return el.dataset[key] || fallback;
    }

    // 2）获取异步的DOM： waitForElement：等待异步渲染的元素出现
    function waitForElement(selector, callback, maxRetries = 10) {
        const el = document.querySelector(selector);
        if (el) {
            callback(el);
        } else if (maxRetries > 0) {
            // 加了 maxRetries，防止元素永远不出现导致无限轮询
            setTimeout(() => waitForElement(selector, callback, maxRetries - 1), 1000);
        } else {
            console.warn(`waitForElement: 10秒找不到元素 ${selector}`);
        }
    }
   
    // 3）加密 email：用 Web Crypto API 做 SHA256, 单向的，不可逆
    async function encryptEmail(email) {
        const normalized = email.trim().toLowerCase(); // 先标准化
        const msgBuffer  = new TextEncoder().encode(normalized);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
        const hashArray  = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }

    // 4）清理对象：移除 null、undefined、空字符串的属性值
    function cleanObject(obj) {
        return Object.fromEntries(
            Object.entries(obj).filter(function([key, value]) {
                return value !== null && value !== undefined && value !== '';
            })
        );
    }

    // 5）处理价格: 返回number
    function formatPrice(value) {
        let num;

        if (typeof value === 'number') {
            if (Number.isNaN(value)) return null;
            num = value;
        } else if (typeof value === 'string') {
            const str = value.trim();
            // 只允许纯数字（可带小数/负号）
            if (!/^-?\d+(\.\d+)?$/.test(str)) return null;
            num = Number(str);
            if (Number.isNaN(num)) return null;
        } else {
            return null;
        }
        const priceStr = (num / 100).toFixed(2);
        return Number(priceStr);
    }

    // 6) deep-处理对象中的null
    function removeNullValues(obj) {
        if (Array.isArray(obj)) {
            return obj
            .map(item => removeNullValues(item))
            .filter(item => item !== null);
        }
        
        if (obj !== null && typeof obj === 'object') {
            return Object.entries(obj).reduce((acc, [key, value]) => {
            const cleaned = removeNullValues(value);
            if (cleaned !== null) {
                acc[key] = cleaned;
            }
            return acc;
            }, {});
        }
        
        return obj;
    }


    // =========================================================
    // 4. 点击埋点：全局事件委托，只初始化一次: // 全局点击：只处理简单的 data-track-click 元素
    // =========================================================
    let clickTrackingInited = false; // 保证只绑定一次click事件委托
    function initGlobalCustomClickTracking() {
        if (clickTrackingInited) return;
        clickTrackingInited = true;

        document.addEventListener('click', function (e) {
            const target = e.target.closest('[data-track-click]');
            if (!target) return;
            const templateEle = target.closest('[data-track-template]');
            const eventObj = {
                event: getDataset(target, 'trackEventName'),
                event_category: getDataset(target, 'trackEventCategory'),
                event_label: getDataset(target, 'trackEventLabel'),
                section_id: getDataset(target, 'trackSectionId'),
                section_name: getDataset(target, 'trackSectionName'),
                template: getDataset(templateEle, 'trackTemplate'),
            };
            track(cleanObject(eventObj));
        });
    }

    // =========================================================
    // 5. 模块初始化方法
    //    模块 init 主要负责：(不负责统一的点击埋点，统一的点击埋点由initGlobalClickTracking做)
    //    - 找模块容器
    //    - 初始化该模块的曝光
    //    - 放模块特殊逻辑（如果以后有）
    // =========================================================

    // ----------- 1） 商品列表、搜索结果的曝光事件 -----------
    function initCollectionPageExposureTracking() {
        const productGrid = document.querySelector('[data-track-grid-exposure]');
        if (!productGrid) return;

        const listId = getDataset(productGrid, 'trackListId');
        const listName = getDataset(productGrid, 'trackListName');
        const sectionId = getDataset(productGrid, 'trackSectionId');
        const sectionName = getDataset(productGrid, 'trackSectionName');

        // 积累曝光的商品
        let exposureBuffer = [];
        let flushTimer = null;

        // 积累够4个或者1000ms内没有新商品进入，就 push
        function flushBuffer() {
            if (!exposureBuffer.length) return;

            for (let i = 0; i < exposureBuffer.length; i += 4) {
                track({ ecommerce: null });
                track({
                    event: 'view_item_list',
                    ecommerce: {
                        item_list_id: listId,
                        item_list_name: listName,
                        section_id: sectionId,
                        section_name: sectionName,
                        items: exposureBuffer.slice(i, i + 4),
                    }
                    
                });
            }
            exposureBuffer = []; // 清空
        }

        function addToBuffer(item) {
            exposureBuffer.push(item);

            if (exposureBuffer.length >= 4) {
                // 积累够4个，立刻 push
                clearTimeout(flushTimer);
                flushBuffer();
            } else {
                // 不够4个，等500ms看有没有新的进来
                clearTimeout(flushTimer);
                flushTimer = setTimeout(flushBuffer, 500);
            }
        }

        // 给每个商品卡绑定 IntersectionObserver
        const itemObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (
                    !entry.isIntersecting ||
                    entry.intersectionRatio < 0.7 ||
                    entry.target.rotFlag
                ) return;

                entry.target.rotFlag = 1;

                addToBuffer({
                    item_id: getDataset(entry.target, 'trackItemId'),
                    item_name: getDataset(entry.target, 'trackItemName'),
                    price: formatPrice(getDataset(entry.target, 'trackItemPrice')),
                    index: getDataset(entry.target, 'trackItemIndex'),
                    item_category: getDataset(entry.target, 'trackItemType'),
                    // item_variant: null,
                    quantity: 1,
                });

                itemObserver.unobserve(entry.target);
            });
        }, {
            threshold: [0, 0.3, 0.7, 1]
        });

        // 首批商品绑定，监听所有商品卡
        productGrid.querySelectorAll('[data-track-item-exposure1]').forEach(function(item) {
            itemObserver.observe(item);
        });

        // show more 新增的 li 自动绑定
        new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType !== 1) return;

                    // 新增的节点本身是 li
                    if (node.matches('[data-track-item-exposure1]')) {
                        if (!node.rotFlag) itemObserver.observe(node);
                    }
                });
            });
        }).observe(productGrid, { // 绑在 ul 上，监听 li 的增减
            childList: true,
            subtree:   false  // show more 是直接追加 li，不需要监听深层
        });
    }

    // ---------- 2.1)公共函数，传入 slider 直接绑定两层 Observer (for: image-with-collection, featured-collection, recently-viewed-products)
    // 模块里面的items的曝光事件 + 单独iamge-with-collection模块的曝光事件
    function bindCarouselSection(slider) {
        const listId = getDataset(slider, 'trackListId');
        const listName = getDataset(slider, 'trackListName');
        const sectionId = getDataset(slider, 'trackSectionId');
        const sectionName = getDataset(slider, 'trackSectionName');
        const templateEle = slider.closest('[data-track-template]');
        const template = getDataset(templateEle, 'trackTemplate');
        // const sectionHeading = getDataset(slider, 'trackSectionHeading');

        let exposureBuffer = [];
        let flushTimer = null;

        function flushBuffer() {
            if (!exposureBuffer.length) return;
            for (let i = 0; i < exposureBuffer.length; i += 4) {
                track({ ecommerce: null });
                track({
                    event: 'view_item_list',
                    ecommerce: {
                        item_list_id: listId,
                        item_list_name: listName,
                        section_id: sectionId,
                        section_name: sectionName,
                        items: exposureBuffer.slice(i, i + 4),
                        template: template,
                    }

                    
                });
            }
            exposureBuffer = [];
        }

        function addToBuffer(item) {
            exposureBuffer.push(item);
            if (exposureBuffer.length >= 4) {
                clearTimeout(flushTimer);
                flushBuffer();
            } else {
                clearTimeout(flushTimer);
                flushTimer = setTimeout(flushBuffer, 500);
            }
        }

        const itemObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (
                    !entry.isIntersecting ||
                    entry.intersectionRatio < 0.7 ||
                    entry.target.rotFlag
                ) return;

                entry.target.rotFlag = 1;
                addToBuffer({
                    item_id: getDataset(entry.target, 'trackItemId'),
                    item_name: getDataset(entry.target, 'trackItemName'),
                    item_brand: 'Flower Knows',
                    // item_variant: null,
                    item_category: getDataset(entry.target, 'trackItemType'),
                    price: formatPrice(getDataset(entry.target, 'trackItemPrice')),
                    index: getDataset(entry.target, 'trackItemIndex'),
                    quantity: 1,
                });
                itemObserver.unobserve(entry.target);
            });
        }, {
            root: slider,
            threshold: [0, 0.7, 1]
        });

        const sliderObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) return;
                sliderObserver.unobserve(slider);
                if (sectionName === 'image-with-collection') {
                    const templateEle = slider.closest('[data-track-template]');
                    track({
                        event: 'view_promotion',
                        creative_name: "Image with Collection",
                        creative_slot: 1,
                        promotion_id: listId,
                        promotion_name: listName,
                        section_id: sectionId,
                        section_name: sectionName,
                        template: getDataset(templateEle, 'trackTemplate'),
                    });
                }
                slider.querySelectorAll('[data-track-item-exposure]').forEach(function(li) {
                    if (!li.rotFlag) itemObserver.observe(li);
                });
            });
        }, { threshold: 0.5 });

        sliderObserver.observe(slider);
    }
    // shop-the-book 曝光事件
    function bindShopTheLookSection(slider) {
        const listId = getDataset(slider, 'trackListId');
        const listName = getDataset(slider, 'trackListName');
        const sectionId = getDataset(slider, 'trackSectionId');
        const sectionName = getDataset(slider, 'trackSectionName');
        const templateEle = slider.closest('[data-track-template]');
        const template = getDataset(templateEle, 'trackTemplate');

        const exposedIds = new Set();
        let isInViewport = false;
        let flkty = null;

        function trackItem(el) {
            if (!el) return;
            const id = getDataset(el, 'trackItemId');
            if (!id || exposedIds.has(id)) return;
            exposedIds.add(id);

            track({ ecommerce: null });
            track({
                event: 'view_item_list',
                ecommerce: {
                    item_list_id: listId,
                    item_list_name: listName,
                    section_id: sectionId,
                    section_name: sectionName,
                    template: template,
                    items: [{
                        item_id: id,
                        item_name: getDataset(el, 'trackItemName'),
                        item_brand: 'Flower Knows',
                        item_category: getDataset(el, 'trackItemType'),
                        price: formatPrice(getDataset(el, 'trackItemPrice')),
                        index: getDataset(el, 'trackItemIndex'),
                        quantity: 1,
                    }],
                }
            });
        }

        const grid = slider.querySelector('.product-grid');

        function tryBindFlickity() {
            let count = 0;
            const timer = setInterval(function () {
                flkty = Flickity.data(grid);

                if (flkty) {
                    clearInterval(timer);
                    if (isInViewport) trackItem(flkty.selectedElement);
                    flkty.on('change', function () {
                        if (!isInViewport) return;
                        trackItem(flkty.selectedElement);
                    });
                }

                if (++count >= 10) clearInterval(timer);
            }, 200);
        }

        // 外层 sliderObserver：section 进视口时触发 view_promotion + 开始监听商品
        const sliderObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                isInViewport = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                if (!isInViewport) return;

                // view_promotion 只触发一次
                sliderObserver.unobserve(slider);
                track({
                    event: 'view_promotion',
                    creative_name: 'Shop the Look',
                    creative_slot: 1,
                    promotion_id: listId,
                    promotion_name: listName,
                    section_id: sectionId,
                    section_name: sectionName,
                    template: template,
                });

                // 绑定 Flickity
                if (!flkty) {
                    tryBindFlickity();
                } else {
                    trackItem(flkty.selectedElement);
                }
            });
        }, { threshold: 0.5 });

        sliderObserver.observe(slider);
    }

    // ---------- 2） 统一 image-with-collection 和 featured-collection 曝光事件 ----------
    function initCarouselSectionExposureTracking(root = document) {
        root.querySelectorAll([
            '[data-track-module-container="image_with_collection_section"]',
            '[data-track-module-container="featured_collection_section"]'
        ].join(',')).forEach(function(section) {
            const slider = section.querySelector('[data-track-exposure]');
            if (!slider) return;
            bindCarouselSection(slider);
        });
        // shop-the-look 单独处理
        root.querySelectorAll('[data-track-module-container="shop_the_look_section"]')
            .forEach(function (section) {
                const slider = section.querySelector('[data-track-exposure]');
                if (!slider) return;
                bindShopTheLookSection(slider);
            });
    }

    // ---------- 2.2） image-with-collection-view-all 点击事件 ----------
    function initImageWithCollectionViewAllTracking() {

        document.addEventListener('click', function(e) {
            const link = e.target.closest('[data-track-collection-view-all]');
            if (!link) return;

            const section = link.closest('[data-track-module-container="image_with_collection_section"]');
            if (!section) return;

            const slider = section.querySelector('[data-track-list-click]');
            if (!slider) return;

            const sectionId = getDataset(slider, 'trackSectionId');
            const sectionName = getDataset(slider, 'trackSectionName');
            const listId = getDataset(slider, 'trackListId');
            const listName = getDataset(slider, 'trackListName');
            const templateEle = slider.closest('[data-track-template]');
            track({
                event: 'select_promotion',
                creative_name: "Image with Collection",
                creative_slot: 1,
                promotion_id: listId,
                promotion_name: listName,
                section_id: sectionId,
                section_name: sectionName,
                template: getDataset(templateEle, 'trackTemplate'),
            });
            
        })
    }

    // ---------- 3） Recently viewed products section 曝光事件 ----------
    function initRecentlyViewedExposureTracking() {
        // 监听 recently-viewed-products 加载事件
        document.addEventListener('recently-viewed:loaded', function(e) {
            const slider = e.target.querySelector('[data-track-exposure]');
            if (!slider) return;
            bindCarouselSection(slider);
        });
    }

    // ---------- 4） 点击商品列表中某个商品card product，跳转详情时触发，包含的位置：-------------
    /*
      - 首页中各个collection的card product
      - 商品列表中的各个card product
      - 搜索结果中的search results页面的card product
      - search bar 弹框 中的 products
      - 购物车recommendation中的商品
      - 购物车中的商品
      - 商品详情页PDP中的complementary_products
    */
    function initProductClickTracking() {

        document.addEventListener('click', function(e) {

            // 找到点击的 a 链接（图片链接或文字链接）
            const link = e.target.closest('[data-track-card-link]');
            if (!link) return;

            // 找到父级 card container（li上的）
            const cardContainer = link.closest('[data-track-item-click]');
            if (!cardContainer) return;

            // 找到父级 list container（ul外面的slider-component；complementary_products用的直接是ul)
            const listContainer = link.closest('[data-track-list-click]');
            if (!listContainer) return;

            const templateEle = listContainer.closest('[data-track-template]');
            const template = getDataset(templateEle, 'trackTemplate');

            const clickItems = [{
                item_id: getDataset(cardContainer, 'trackItemId'),
                item_name: getDataset(cardContainer, 'trackItemName'),
                item_brand: 'Flower Knows',
                price: formatPrice(getDataset(cardContainer, 'trackItemPrice')),
                index: getDataset(cardContainer, 'trackItemIndex'),
                item_category: getDataset(cardContainer, 'trackItemType'),
                item_variant: getDataset(cardContainer, 'trackItemVariant'),
                quantity: parseInt(getDataset(cardContainer, 'trackItemQuantity') || 0) || 1,
            }];

            const cleanedItems = removeNullValues(clickItems)

            const trackObj = {
                event: 'select_item',
                ecommerce: {
                    item_list_id: getDataset(listContainer, 'trackListId'),
                    item_list_name: getDataset(listContainer, 'trackListName'),
                    section_id: getDataset(listContainer, 'trackSectionId'),
                    section_name: getDataset(listContainer, 'trackSectionName'),
                    items: cleanedItems,
                    template: template,
                }
            }

            // if (getDataset(listContainer, 'trackListName') === 'cart_recommendations') {
            //     delete trackObj.ecommerce.section_name;
            //     delete trackObj.ecommerce.section_id;
            //     delete trackObj.template;
            // }

            track({ ecommerce: null });
            track(trackObj);

        });
    }

    // ---------- 5） 点击商品列表中某个商品card的快速加购 add-to-cart, 包含的位置：首页中各个collection的card product、商品列表中的各个card product（collection、search results）
    // 确定pixel来做；先关闭调用
    function initAddToCartClickTracking() {
        document.addEventListener('click', function(e){
            // 找到 点击的 add-to-cart 按钮
            const addToCartBtn = e.target.closest('[data-track-add-to-cart]');
            if (!addToCartBtn) return;
            const itemvariantTitle = getDataset(addToCartBtn, 'trackItemVariant');

            // 找到父级 card container（li上的）
            const cardContainer = addToCartBtn.closest('[data-track-item-click]');
            if (!cardContainer) return;

            const addItems = [{
                item_id: getDataset(cardContainer, 'trackItemId'),
                item_name: getDataset(cardContainer, 'trackItemName'),
                item_brand: 'Flower Knows',
                price: formatPrice(getDataset(cardContainer, 'trackItemPrice')),
                index: getDataset(cardContainer, 'trackItemIndex'),
                item_variant: itemvariantTitle,
                quantity: 1,
            }];

            const cleanedItems = removeNullValues(addItems)
            track({ ecommerce: null });
            track({
                event: 'add_to_cart',
                ecommerce: {
                    currency: 'USD',
                    value: formatPrice(getDataset(cardContainer, 'trackItemPrice')),
                    items: cleanedItems,
                }
                
            });

        })

    }

    // ---------- 6） 监听购物车open事件：已在global.js中 dispatch 事件：推荐商品模块和购物车打开一起展示的曝光事件 ----------
    function initCartDrawerExposureTracking() {

        document.addEventListener('cartdrawer:opened', function() {
            const miniCart = document.getElementById('mini-cart');
            if (!miniCart) return;

            // 购物车商品曝光
            const cartItems = miniCart.querySelectorAll('[data-track-cart-item]');
            const newItems  = [];

            cartItems.forEach(function(item) {
                // const variantId = getDataset(item, 'trackVariantId');
                // if (exposedCartItemIds.has(variantId)) return;
                // exposedCartItemIds.add(variantId);
                newItems.push({
                    item_brand: 'Flower Knows',
                    index: getDataset(item, 'trackItemIndex'),
                    item_id: getDataset(item, 'trackItemId'),
                    item_name: getDataset(item, 'trackItemName'),
                    item_variant: getDataset(item, 'trackItemVariant'),
                    price: formatPrice(getDataset(item, 'trackItemPrice')),
                    quantity: parseInt(getDataset(item, 'trackItemQuantity') || 0) || 1,
                    item_category: getDataset(item, 'trackItemType'),
                });
            });
            const subtotalEle = document.querySelector('[data-track-cart-subtotal]');
            const subtotal = subtotalEle ? getDataset(subtotalEle, 'trackCartSubtotal') : null;

            track({ ecommerce: null });
            track({
                event: 'view_cart',
                ecommerce: {
                    currency: 'USD',
                    section_id: 'cart-drawer',
                    section_name: 'cart-drawer',
                    value: formatPrice(subtotal),
                    items: removeNullValues(newItems),
                }
            });
            // 推荐产品打开时（而不是更新时
            const cartRecommendations = miniCart.querySelector('[data-track-cart-recommendations]');
            if (!cartRecommendations) return;
            const recItems = cartRecommendations.querySelectorAll('[data-track-cart-rec-item]');
            if (!recItems.length) return;
            const newRecItems  = [];
            recItems.forEach(function(item) {
                newRecItems.push({
                    item_brand: 'Flower Knows',
                    index: getDataset(item, 'trackItemIndex'),
                    item_id: getDataset(item, 'trackItemId'),
                    item_name: getDataset(item, 'trackItemName'),
                    // item_variant: null,
                    price: formatPrice(getDataset(item, 'trackItemPrice')),
                    quantity: parseInt(getDataset(item, 'trackItemQuantity') || 0) || 1,
                    item_category: getDataset(item, 'trackItemType'),
                });
            });

            for (let i = 0; i < newRecItems.length; i+=4) {
                track({ ecommerce: null });
                track({
                    event: 'view_item_list',
                    ecommerce: {
                        section_id: 'cart_recommendations',
                        section_name: 'cart_recommendations',
                        item_list_id: 'cart_recommendations',
                        item_list_name: 'cart_recommendations',
                        items: newRecItems.slice(i, i+4),
                    }
                });
            }
        });

        // cart-recommendations fetch了新内容，需要更新推荐商品模块的曝光数据
        document.addEventListener('cart-recommendations:fetch', function() {
            const miniCart = document.getElementById('mini-cart');
            if (!miniCart) return;
            const cartRecommendations = miniCart.querySelector('[data-track-cart-recommendations]');
            if (!cartRecommendations) return;
            const recItems = cartRecommendations.querySelectorAll('[data-track-cart-rec-item]');
            if (!recItems.length) return;
            const newRecItems  = [];
            recItems.forEach(function(item) {
                newRecItems.push({
                    item_brand: 'Flower Knows',
                    index: getDataset(item, 'trackItemIndex'),
                    item_id: getDataset(item, 'trackItemId'),
                    item_name: getDataset(item, 'trackItemName'),
                    // item_variant: null,
                    price: formatPrice(getDataset(item, 'trackItemPrice')),
                    quantity: parseInt(getDataset(item, 'trackItemQuantity') || 0) || 1,
                    item_category: getDataset(item, 'trackItemType'),
                });
            });

            for (let i = 0; i < newRecItems.length; i+=4) {
                track({ ecommerce: null });
                track({
                    event: 'view_item_list',
                    ecommerce: {
                        section_id: 'cart_recommendations',
                        section_name: 'cart_recommendations',
                        item_list_id: 'cart_recommendations',
                        item_list_name: 'cart_recommendations',
                        items: newRecItems.slice(i, i+4),
                    }
                });
            }

        });
    }

    // ----------7）announcement-bar的曝光&点击事件
    function initAnnouncementBarTracking() {
        const barEl = document.querySelector('announcement-bar');
        const sliderEl = barEl?.querySelector('.announcement-slider');
        if (!barEl || !sliderEl) return;
        const slideCount = sliderEl.querySelectorAll(`.announcement-slider__slide[data-index]`)?.length || 0;
        const isCarousel = barEl.dataset.layout === 'carousel' ||
            (theme.config.mqlSmall && barEl.dataset.mobileLayout === 'carousel');

        const exposedSlideIndexes = new Set();
        let isInViewport = false;
        let flkty = null;

        function getSlideContent(slide) {
            return slide.querySelector('.small-hide.medium-hide')?.textContent.trim() ||
                slide.querySelector('.announcement-text')?.textContent.trim() ||
                '';
        }

        function trackSlide(index) {
            if (index == null || exposedSlideIndexes.has(index)) return;

            const slide = sliderEl.querySelector(
                `.announcement-slider__slide[data-index="${index}"]`
            );
            if (!slide) return;

            exposedSlideIndexes.add(index);
            if (exposedSlideIndexes.size === slideCount) {
                observer.disconnect();
            }

            track({
                event: 'view_promotion',
                creative_name: 'Announcement Bar',
                creative_slot: index + 1,
                promotion_id: index + 1,
                promotion_name: getSlideContent(slide)
            });
        }

        // Flickity 绑定
        function tryBindFlickity() {
            let count = 0;

            const timer = setInterval(function () {
                flkty = barEl.flickity;

                if (flkty) {
                    clearInterval(timer);

                    // 首屏当前 slide
                    if (isInViewport) {
                        trackSlide(flkty.selectedIndex);
                    }

                    flkty.on('change', function (index) {
                        if (!isInViewport) return; 
                        trackSlide(index);
                    });
                }

                count++;
                if (count >= 10) {
                    clearInterval(timer);
                }
            }, 200);
        }

        // 视口监听
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                isInViewport = entry.isIntersecting && entry.intersectionRatio >= 0.8;

                if (!isInViewport) return;

                if (!isCarousel) {
                    // marquee：进入视口时一次性补齐
                    sliderEl.querySelectorAll('.announcement-slider__slide').forEach(function(slide) {
                        trackSlide(parseInt(slide.dataset.index || 0));
                    });
                    return;
                }

                // carousel
                if (!flkty) {
                    tryBindFlickity();
                } else {
                    // 回到视口时补当前 slide
                    trackSlide(flkty.selectedIndex);
                }
            });
        }, {
            threshold: [0, 0.8]
        });

        observer.observe(barEl);

        // ===== 点击事件 =====
        document.addEventListener('click', function(e) {
            const link = e.target.closest('announcement-bar .announcement-link');
            if (!link) return;

            const slide = link.closest('.announcement-slider__slide');
            const index = parseInt(slide?.dataset.index || 0);

            track({
                event: 'select_promotion',
                creative_name: 'Announcement Bar',
                creative_slot: index + 1,
                promotion_id: index + 1,
                promotion_name: getSlideContent(slide),
            });
        });
    }

    // ----------8）slideshow的曝光事件 ----------
    function initSlideshowTracking(root = document) {
        // ===== 处理所有 slideshow section =====
        root.querySelectorAll('[data-track-module-container="slideshow_section"]').forEach(function(section) {
            const sectionId = getDataset(section, 'trackSectionId');
            const sectionName = getDataset(section, 'trackSectionName');

            const multiple = section.querySelector('[data-track-slideshow="multiple"]');
            const single   = section.querySelector('[data-track-slideshow="single"]');
            const templateEle = section.closest('[data-track-template]');
            const template = getDataset(templateEle, 'trackTemplate');
            if (multiple) {
                initMultipleSlideshow(multiple, sectionId, sectionName, template);
            } else if (single) {
                initSingleSlideshow(single, sectionId, sectionName, template);
            }
        });
        // ===== 多个 block =====
        function initMultipleSlideshow(el, sectionId, sectionName, template) {
            const exposedSlideIndexes = new Set();
            let isInViewport = false;
            let flkty = null;
            const slideCount = el.querySelectorAll('.slideshow__box[data-track-slide-index]')?.length || 0;

            function trackSlide(index) {
                if (index == null || exposedSlideIndexes.has(index)) return;

                const box = el.querySelector(
                    `.slideshow__box[data-track-slide-index="${index}"]`
                );
                // if (!box) return;

                exposedSlideIndexes.add(index);
                if (exposedSlideIndexes.size === slideCount) {
                    observer.disconnect();
                }

                track({
                    event: 'view_promotion',
                    creative_name: 'Slideshow',
                    creative_slot: index + 1,
                    promotion_id: index + 1,
                    promotion_name: getDataset(box, 'trackSlideTitle'),
                    section_id: sectionId,
                    section_name: sectionName,
                    template: template,
                });
            }

            // 绑定 Flickity
            function tryBindFlickity() {
                let count = 0;

                const timer = setInterval(function () {
                    flkty = el.flickityContent;

                    if (flkty) {
                        clearInterval(timer);

                        // 当前 slide（首屏）
                        if (isInViewport) {
                            trackSlide(flkty.selectedIndex);
                        }

                        // 监听切换
                        flkty.on('change', function (index) {
                            if (!isInViewport) return; // 不在视口不埋点
                            trackSlide(index);
                        });
                    }

                    count++;
                    if (count >= 10) {
                        clearInterval(timer); // 最多尝试 10 次
                    }
                }, 200);
            }

            // 监听是否在视口
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    isInViewport = entry.isIntersecting && entry.intersectionRatio >= 0.5;

                    if (isInViewport) {
                        // 首次进入时尝试绑定
                        if (!flkty) {
                            tryBindFlickity();
                        } else {
                            // 已经绑定过 → 直接补一次曝光（防止回来时漏）
                            trackSlide(flkty.selectedIndex);
                        }
                    }
                });
            }, {
                threshold: [0, 0.5]
            });

            observer.observe(el);
        }

        // ===== 单个 block =====
        function initSingleSlideshow(el, sectionId, sectionName, template) {
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting) return;
                    observer.unobserve(el);

                    track({
                        event: 'view_promotion',
                        creative_name: 'Slideshow',
                        creative_slot: 1,
                        promotion_id: 1,
                        promotion_name: getDataset(el, 'trackSlideTitle'),
                        section_id: sectionId,
                        section_name: sectionName,
                        template: template,
                    });
                });
            }, { threshold: 0.5 });

            observer.observe(el);
        }
    }

    // ----------8）slideshow的点击事件 ----------
    function initSlideshowClickTracking() {
        document.addEventListener('click', function(e) {
            const btn = e.target.closest('[data-track-slide-link="btn"]');
            if (btn){
                const section = btn.closest('[data-track-module-container="slideshow_section"]');
                const slide = btn.closest('[data-track-slide-index]');
                const slot = getDataset(slide, 'trackSlideIndex')? parseInt(getDataset(slide, 'trackSlideIndex') || 0) + 1 : null;
                const templateEle = section.closest('[data-track-template]');
                track({
                    event: 'select_promotion',
                    creative_name: 'Slideshow',
                    creative_slot: slot,
                    promotion_id: slot,
                    promotion_name: getDataset(slide, 'trackSlideTitle'),
                    section_id: getDataset(section, 'trackSectionId'),
                    section_name: getDataset(section, 'trackSectionName'),
                    template: getDataset(templateEle, 'trackTemplate'),
                });
            }
            const link = e.target.closest('[data-track-slide-link="image"]');
            if (link){
                const section = link.closest('[data-track-module-container="slideshow_section"]');
                const slot = getDataset(link, 'trackSlidePosition')? parseInt(getDataset(link, 'trackSlidePosition') || 0) : null;
                const templateEle = section.closest('[data-track-template]');
                track({
                    event: 'select_promotion',
                    creative_name: 'Slideshow',
                    creative_slot: slot,
                    promotion_id: slot,
                    promotion_name: getDataset(link, 'trackSlideTitle'),
                    section_id: getDataset(section, 'trackSectionId'),
                    section_name: getDataset(section, 'trackSectionName'),
                    template: getDataset(templateEle, 'trackTemplate'),
                });
            }

        });
    }

    // ---------- 9）collection list 曝光事件 ----------
    function initCollectionListExposureTracking(root = document) {
        root.querySelectorAll('[data-track-module-container="collection_list_section"]').forEach(function(section) {
            const slider = section.querySelector('[data-track-exposure]');
            if (!slider) return;

            const sectionId   = getDataset(slider, 'trackSectionId');
            const sectionName = getDataset(slider, 'trackSectionName');
            const templateEle = section.closest('[data-track-template]');
            function trackItem(item) {
                track({
                    event: 'view_promotion',
                    creative_name: 'Collection List',
                    creative_slot: getDataset(item, 'trackItemIndex'),
                    promotion_id: getDataset(item, 'trackItemIndex'),
                    promotion_name: getDataset(item, 'trackItemName'),
                    section_id: sectionId,
                    section_name: sectionName,
                    template: getDataset(templateEle, 'trackTemplate'),
                });
            }

            // item observer
            const itemObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (
                        !entry.isIntersecting ||
                        entry.intersectionRatio < 0.7 ||
                        entry.target.rotFlag
                    ) return;

                    entry.target.rotFlag = 1;
                    trackItem(entry.target);
                    itemObserver.unobserve(entry.target);
                });
            }, {
                root: slider,
                threshold: [0, 0.7, 1]
            });

            // slider observer
            const sliderObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting) return;
                    sliderObserver.unobserve(slider);

                    slider.querySelectorAll('[data-track-item-exposure]').forEach(function(item) {
                        if (!item.rotFlag) itemObserver.observe(item);
                    });
                });
            }, { threshold: 0.5 });

            sliderObserver.observe(slider);
        });
    }

    // ---------- 9）collection list 点击事件----------
    function initCollectionListClickTracking() {
        document.addEventListener('click', function(e) {

            // 找到被点击的 link
            const link = e.target.closest('[data-track-collection-link]');
            if (!link) return;

            // 找到对应的 item
            const item = link.closest('[data-track-item-exposure]');
            if (!item) return;

            // 确认在 collection_list_section 内
            const section = item.closest('[data-track-module-container="collection_list_section"]');
            if (!section) return;

            // 找到 slider 拿 section 信息
            const slider = section.querySelector('[data-track-exposure]');
            const templateEle = section.closest('[data-track-template]');
            track({
                event: 'select_promotion',
                creative_name: 'Collection List',
                creative_slot: getDataset(item, 'trackItemIndex'), // 从 item 上直接读
                promotion_id: getDataset(item, 'trackItemIndex'),
                promotion_name: getDataset(item, 'trackItemName'),  // 从 item 上直接读
                section_id: getDataset(slider, 'trackSectionId'),
                section_name: getDataset(slider, 'trackSectionName'),
                template: getDataset(templateEle, 'trackTemplate'),
            });
        });
    }

    // ---------- 10）image-with-promotions 点击事件1+4 ----------
    function initImageWithPromotionClickTracking() {
        document.addEventListener('click', function(e) {

            const link = e.target.closest('[data-track-promo-type]');
            if (!link) return;
            const section = link.closest('[data-track-module-container="image_with_promotions_section"]');
            if (!section) return;
            const sectionId = getDataset(section, 'trackSectionId');
            const templateEle = section.closest('[data-track-template]');
            if (link.dataset.trackPromoType === 'image') {
                track({
                    event: 'select_promotion',
                    creative_name: 'Image with Promotions',
                    creative_slot: 5,
                    promotion_id: 5,
                    promotion_name: getDataset(section, 'trackPromotionName'), // heading
                    section_id: sectionId,
                    section_name: 'image-with-promotions',
                    template: getDataset(templateEle, 'trackTemplate'),
                });
            } else if (link.dataset.trackPromoType === 'promotion') {
                const promoItem = link.closest('[data-track-promo-index]');
                if (!promoItem) return;
                track({
                    event: 'select_promotion',
                    creative_name: 'Image with Promotions',
                    creative_slot: getDataset(promoItem, 'trackPromoIndex'),
                    promotion_id: getDataset(promoItem, 'trackPromoIndex'),
                    promotion_name: getDataset(promoItem, 'trackPromoName'),
                    section_id: sectionId,
                    section_name: 'image-with-promotions',
                    template: getDataset(templateEle, 'trackTemplate'),
                });
            }
        });
    }

    // ---------- 10.1）image-with-promotions 曝光事件：整个模块的 ----------
    function initImageWithPromotionExposureTracking(root = document) {
        const sections = root.querySelectorAll('[data-track-module-container="image_with_promotions_section"]');
        if (!sections.length) return;
        sections.forEach(function(section) {
            const slider = section.querySelector('[data-track-exposure]');
            if (!slider) return;

            const sectionId = getDataset(section, 'trackSectionId');
            const templateEle = section.closest('[data-track-template]');

            const itemObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting || entry.intersectionRatio < 0.7 || entry.target.rotFlag) return;
                    entry.target.rotFlag = 1;
                    track({
                        event: 'view_promotion',
                        creative_name: 'Image with Promotions',
                        creative_slot: getDataset(entry.target, 'trackPromoIndex'),
                        promotion_id: getDataset(entry.target, 'trackPromoIndex'),
                        promotion_name: getDataset(entry.target, 'trackPromoName'),
                        section_id: sectionId,
                        section_name: 'image-with-promotions',
                        template: getDataset(templateEle, 'trackTemplate'),
                    })
                    itemObserver.unobserve(entry.target);
                });
            }, {
                root: slider,
                threshold: [0, 0.7, 1]
            })


            const sliderObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting) return;
                    sliderObserver.unobserve(slider);
                    track({
                        event: 'view_promotion',
                        creative_name: 'Image with Promotions',
                        creative_slot: 5,
                        promotion_id: 5,
                        promotion_name: getDataset(section, 'trackPromotionName'), // heading
                        section_id: sectionId,
                        section_name: 'image-with-promotions',
                        template: getDataset(templateEle, 'trackTemplate'),
                    });
                    slider.querySelectorAll('[data-track-promo-index]').forEach(function(promoItem) {
                        if (!promoItem.rotFlag) {
                            itemObserver.observe(promoItem);
                        }
                    });
                });
            }, { threshold: 0.5 });

            sliderObserver.observe(slider);
        });
    }
  
    // ---------- 11）商品详情页PDP的曝光事件
    function initProductMainExposureTracking(root = document) {
        const productExposure = root.querySelector('[data-track-product-exposure]');
        if (!productExposure) return;

        const itemId = getDataset(productExposure, 'trackProductId');
        const itemName = getDataset(productExposure, 'trackProductName');
        const itemCategory = getDataset(productExposure, 'trackProductType');
        const variant = getDataset(productExposure, 'trackProductVariant');    
        const value = getDataset(productExposure, 'trackProductPrice');

        const mainObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) return;
                mainObserver.unobserve(productExposure);

                const trackObj = {
                    event: 'view_item',
                    ecommerce: {
                        currency: 'USD',
                        value: formatPrice(value),
                        items: [{
                            item_id: itemId,
                            item_name: itemName,
                            item_category: itemCategory,
                            item_brand: 'Flower Knows',
                            item_variant: variant,
                            price: formatPrice(value),
                            index: 1,
                            quantity: 1,
                        }]
                    }
                    
                }
                const cleanedObj = removeNullValues(trackObj)
                track({ ecommerce: null });
                track(cleanedObj);
            });
        }, { threshold: 0.3 });

        mainObserver.observe(productExposure);
    }

    // -------------- 商品quick view 的点击事件
    function initQuickViewClickTracking() {
        document.addEventListener('click', function(e) {
            // 找到点击的 quick-view 按钮
            const quickViewBtn = e.target.closest('[data-track-quick-view]');
            if (!quickViewBtn) return;

             if (!e.isTrusted) return; // 只监听用户点击的

            // 找到父级 card container（li上的）
            const cardContainer = quickViewBtn.closest('[data-track-item-click]');
            if (!cardContainer) return;

            // 找到父级 list container（ul外面的slider-component；complementary_products用的直接是ul)
            const listContainer = quickViewBtn.closest('[data-track-list-click]');
            if (!listContainer) return;

            const templateEle = listContainer.closest('[data-track-template]');
            const template = getDataset(templateEle, 'trackTemplate');

            const clickItems = [{
                item_id: getDataset(cardContainer, 'trackItemId'),
                item_name: getDataset(cardContainer, 'trackItemName'),
                item_brand: 'Flower Knows',
                price: formatPrice(getDataset(cardContainer, 'trackItemPrice')),
                index: getDataset(cardContainer, 'trackItemIndex'),
                item_category: getDataset(cardContainer, 'trackItemType'),
                item_variant: getDataset(cardContainer, 'trackItemVariant'),
                quantity: parseInt(getDataset(cardContainer, 'trackItemQuantity') || 0) || 1,
            }];
            track({ ecommerce: null });
            track({
                event: 'viewed_item',
                ecommerce: {
                    // item_list_id: getDataset(listContainer, 'trackListId'),
                    // item_list_name: getDataset(listContainer, 'trackListName'),
                    section_id: getDataset(listContainer, 'trackSectionId'),
                    section_name: getDataset(listContainer, 'trackSectionName'),
                    value: formatPrice(getDataset(cardContainer, 'trackItemPrice')),
                    currency: 'USD',
                    items: removeNullValues(clickItems),
                    template: template,
                }
                
            });
        })
    }

    /*
        App的模块
        - 全局的cookie banner
        - newsletter form 单独绑定submit事件，因为要获取email加密
        - predictive search 单独绑定submit事件
        - moast app 单独绑定点击事件
    */
    // ---------- 12）全局的cookie banner ----------
    function initCookieBannerTracking() {
        waitForElement('.shopify-pc__banner__wrapper', function(banner) {

            // 找到接受按钮
            const acceptBtn = banner.querySelector('#shopify-pc__banner__btn-accept');
            // 找到拒绝按钮  
            const declineBtn = banner.querySelector('#shopify-pc__banner__btn-decline');

            acceptBtn?.addEventListener('click', function() {
                track({
                    event: 'Consent_event',
                    event_category: 'Cookie Consent Popup Button',
                    event_label: 'Accept',
                });
            });

            declineBtn?.addEventListener('click', function() {
                track({
                    event: 'Consent_event',
                    event_category: 'Cookie Consent Popup Button',
                    event_label: 'Decline',
                });
            });
        });
    }

    // ---------- 13）newsletter form 单独绑定submit事件，因为要获取email加密 ----------
    function initNewsletterFormTracking() {
        const newsletterForm = document.querySelector('form.newsletter-form');
        if (!newsletterForm) return;
        const emailInput = newsletterForm.querySelector('input[name="contact[email]"]');
        if (!emailInput) return;
        newsletterForm.addEventListener('submit', async function(e) {
            // 校验邮箱不为空
            if (!emailInput.value) return;

            const encryptedEmail = await encryptEmail(emailInput.value);

            track({
                event:      'Public_event',
                event_category:  'Bottom Subscribe Button',
                event_label:     'Email_Subscribe_click',
                encrypted_email: encryptedEmail,
            });
        });
    }

    // ---------- 14）predictive search 单独绑定submit事件 ----------
    function initPredictiveSearchTracking() {
        const predictiveSearchForms = document.querySelectorAll('form.search-modal__form');
        if (!predictiveSearchForms.length) return;

        predictiveSearchForms.forEach((form) => {
            const searchInput = form.querySelector('input[name="q"]');
            if (!searchInput) return;

            form.addEventListener('submit', function(e) {
                const keyword = searchInput.value.trim();
                if (!keyword) return;

                track({
                    event: 'Public_event',
                    event_category: 'Top Search Bar',
                    event_label: keyword,
                });
            });
        });
    }

    // ---------- 15）moast app 单独绑定点击事件 ----------
    function initMoastAppTracking() {
        waitForElement('moast-carousel', function (moastEl) {
            waitForShadowRootReady(moastEl, function (shadowRoot) {
                const existingWrapper = shadowRoot.querySelector('.carousel-wrapper');
                if (existingWrapper) {
                    onCarouselReady(moastEl, shadowRoot, existingWrapper);
                    return;
                }

                let shadowObserver;
                const timeout = setTimeout(function () {
                    if (shadowObserver) shadowObserver.disconnect();
                    console.warn('Moast: carousel-wrapper 30秒内未出现，停止监听');
                }, 30000);

                shadowObserver = new MutationObserver(function (mutations, obs) {
                    const wrapper = shadowRoot.querySelector('.carousel-wrapper');
                    if (!wrapper) return;

                    clearTimeout(timeout);
                    obs.disconnect();
                    onCarouselReady(moastEl, shadowRoot, wrapper);
                });

                shadowObserver.observe(shadowRoot, {
                    childList: true,
                    subtree: true
                });
            });
        });

        // helper: 
        // 1. 等待 shadowRoot 准备好
        function waitForShadowRootReady(host, callback, maxRetries = 20) {
            const shadowRoot = host.shadowRoot;
            if (shadowRoot) {
                callback(shadowRoot);
            } else if (maxRetries > 0) {
                setTimeout(function () {
                    waitForShadowRootReady(host, callback, maxRetries - 1);
                }, 500);
            } else {
                console.warn('Moast: shadowRoot 未出现', host);
            }
        }
        // 2. carousel-wrapper 出现后的初始化逻辑
        function onCarouselReady(moastEl, shadowRoot, wrapper) {

            if (shadowRoot.__moastTrackingBound) return;
            shadowRoot.__moastTrackingBound = true;

            shadowRoot.addEventListener('click', function (e) {
                const clickBtn = e.target.closest('.card__player.is-button'); // 点击视频

                const clickPagination = e.target.closest('.carousel__prev, .carousel__next'); // 点击左右按钮
                
                if (clickPagination) {
                    track({
                        event: 'Home_event',
                        event_category: 'Moast App_Switch Section',
                        event_label: 'Video Section Switch'
                    });
                    return;
                }
                if (clickBtn) {
                    const item = clickBtn.closest('[role="listitem"]')
                    if (!item) return;

                    const itemIndex = item && !isNaN(item.dataset?.index)
                        ? parseInt(item.dataset.index, 10) + 1
                        : null;

                    const itemAriaLabel = item?.getAttribute('aria-label') || '';
                    const blockId = moastEl.getAttribute('block-id') || '';

                    track({
                        event: 'Home_event',
                        event_category: 'Moast App_Video Section',
                        video_id: blockId && itemIndex ? `${blockId}__${itemIndex}` : itemIndex,
                        event_label: itemAriaLabel
                    });
                    return;
                }
                
            });
        }
    }

    // ---------- 16）注册弹框klaviyo 悬浮按钮的点击事件 ----------
    // id固定的，那么可以直接区分美国非美国的点击事件
    function initKlaviyoFormTracking() {
        // 1) 悬浮按钮是动态插入的，最好的办法是在document上监听点击事件
        document.addEventListener('click', function(e) {
            
            const teaserBtn = e.composedPath().find(function(el) {
                // 匹配 class 中包含 kl-teaser- 的元素
                return el.classList?.value?.includes('kl-teaser-');
            });

            if (!teaserBtn) return;
            // 防止和全局监听重复（如果 teaserBtn 同时有 data-track-click）
            if (teaserBtn.hasAttribute('data-track-click')) return;
            const teaserId = Array.from(teaserBtn.classList).find(cls => cls.startsWith('kl-teaser-')).split('-').pop();
            track({
                event: 'Public_event',
                event_category: 'Left Discount Button',
                event_label: teaserId,
            });

           
        });
        // 2) 1.用户首次进入页面自动弹form弹框。2.点击teaser后也会弹form弹框。找 form 绑定 submit 事件
        let formTrackingBound = false;

        waitForElement('[data-testid^="klaviyo-form-"]', function(form) {
            if (formTrackingBound) return;
            formTrackingBound = true;

            const formId = form.dataset.testid.split('-').pop();

            // 2.3）监听关闭按钮点击事件
            // const formParent = form.closest('div'); // 直接的父元素
            // if (formParent) {
            //     const closeBtn = formParent.querySelector('button[aria-label="Close dialog"]'); // 关闭按钮
            //     if (closeBtn) {
            //         closeBtn.addEventListener('click', function(e) {
            //             track({
            //                 event: 'Public_event',
            //                 event_category: 'Klaviyo Popup Form_Close',
            //                 event_label: formId,
            //             });
            //         });
            //     }
            // }
            const dialogDiv = document.querySelector('div[role="dialog"][aria-modal="true"][aria-label="POPUP Form"]'); // 获取display:none 和flex变换的div
            if (dialogDiv) {
                let hasTrackedExposure = false;
                const observer = new MutationObserver(function (mutations) {
                    for (const mutation of mutations) {
                        if (mutation.attributeName !== 'style') continue;
                        const isVisible = dialogDiv.style.display === 'flex';
                        if (isVisible && !hasTrackedExposure) {
                            hasTrackedExposure = true;
                            track({
                                event: 'Public_event',
                                event_category: 'Klaviyo Popup Form_Exposure',
                                event_label: formId,
                            });
                        } else if (!isVisible) {
                            hasTrackedExposure = false;
                        }
                    }
                });
                observer.observe(dialogDiv, { attributes: true, attributeFilter: ['style'] });

                // 首次自动弹出时 dialogDiv 已经是 flex，直接在这里捕获
                if (dialogDiv.style.display === 'flex') {
                    hasTrackedExposure = true;
                    track({
                        event: 'Public_event',
                        event_category: 'Klaviyo Popup Form_Exposure',
                        event_label: formId,
                    });
                }

                // 关闭按钮也从 dialogDiv 里找，范围更准确
                const closeBtn = dialogDiv.querySelector('button[aria-label="Close dialog"]');
                if (closeBtn) {
                    closeBtn.addEventListener('click', function () {
                        track({
                            event: 'Public_event',
                            event_category: 'Klaviyo Popup Form_Close',
                            event_label: formId,
                        });
                    });
                }
            }

            async function handleFormSubmit() {
                const emailInput = form.querySelector('input[type="email"]') || form.querySelector('input[name="email"]');
                const phoneInput = form.querySelector('input[type="tel"]') || form.querySelector('input[name="phone-number"]');

                const email = emailInput?.value?.trim();
                const phone = phoneInput?.value?.trim();

                if (email) {
                    track({
                        event:      'Public_event',
                        event_category:  'Klaviyo Popup Form_Email',
                        event_label:     formId,
                        encrypted_email: await encryptEmail(email)
                    });
                } else if (phone) {
                    track({
                        event:      'Public_event',
                        event_category:  'Klaviyo Popup Form_Phone',
                        event_label:     formId,
                        encrypted_phone: encryptPhone(phone)
                    });
                }
            }

            // 2.1）监听 submit（enter 键）
            form.addEventListener('submit', handleFormSubmit);

            // 2.2）监听按钮 click
            // 用事件委托绑在 form 上，第二步的按钮也能捕获
            form.addEventListener('click', function(e) {
                const btn = e.target.closest('button');
                if (!btn) return;
                const isSubmitBtn = btn.closest('[data-testid="form-component"]');      
                if (!isSubmitBtn) return;
                handleFormSubmit();
            });
        }, 20);
    }

    // =========================================================
    // 6. 模块注册表
    //    后面新增模块，往这里加就行
    // =========================================================
    const moduleInitializers = [
        initGlobalCustomClickTracking, // 全局自定义事件
        initCollectionPageExposureTracking, // 商品列表 曝光
        initCarouselSectionExposureTracking, // 统一 image-with-collection 和 featured-collection 曝光事件
        initImageWithCollectionViewAllTracking, // image-with-collection view all 点击事件
        initRecentlyViewedExposureTracking, // Recently viewed products section 曝光

        initProductClickTracking, // 所有的 Product card click 事件
        // initAddToCartClickTracking, // 所有的 Product card click add-to-cart 事件

        initCartDrawerExposureTracking, // 购物车抽屉 曝光事件,提交购物车中的所有items

        initCookieBannerTracking, // Cookie banner
        initNewsletterFormTracking, // Newsletter form 单独绑定submit事件，要获取email加密
        initPredictiveSearchTracking, // Predictive search form 单独绑定submit事件
        // initMoastAppTracking, // Moast app 单独绑定点击事件

        initKlaviyoFormTracking, // Klaviyo form 提交事件

        initAnnouncementBarTracking, // Announcement bar 曝光&点击事件
        initSlideshowTracking, // Slideshow 曝光事件
        initSlideshowClickTracking, // Slideshow 点击事件

        initCollectionListClickTracking, // Collection list 点击事件
        initCollectionListExposureTracking, // Collection list 曝光事件
        initImageWithPromotionClickTracking, // Image with promotions 点击事件
        initImageWithPromotionExposureTracking, // Image with promotions 曝光事件
        // initProductMainExposureTracking, // 商品详情页的曝光事件
        initQuickViewClickTracking, // quick view 事件

    ];

    function initModules(root = document) {
        moduleInitializers.forEach(function (initModule) {
            initModule(root);
        });
    }

    // =========================================================
    // 7. 页面初始化入口
    // =========================================================
    function initPageTracking(root = document) {
        initModules(root);
    }

    function onReady() {
        initPageTracking(document);
    }

    // ====================== 入口：等待 DOMContentLoaded 事件触发
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onReady);
    } else {
        onReady();
    }

})();